import { FirestoreCollections, ID } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';

export type GetTaskByIdDocOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  taskId: ID;
};

export const getTaskByIdDoc = <TDocRef, TDb = FirestoreInstance>(
  options: GetTaskByIdDocOptions<TDocRef, TDb>,
): TDocRef => {
  const { db, doc, taskId } = options;
  return doc(db, FirestoreCollections.Tasks, taskId);
};
